import viewIconSvg from "static/images/view-icon.svg";
import IconLinkButton from "components/common/controls/IconLinkButton";

interface Props {
  onViewClick: () => void;
}

export default function InvoiceGridActions(props: Props) {
  const { onViewClick } = props;
  const handleViewClick = () => {
    onViewClick();
  };

  return (
    <>
      <div
        className="hover:bg-promGray3 px-0.5 py-1 hover:border rounded cursor-pointer"
        onClick={handleViewClick}
      >
        <IconLinkButton text="" icon={viewIconSvg} onClick={() => {}} />
      </div>
    </>
  );
}
